const graphUrl = process.env.GRAPH_URL || "no-graphQL-url";

export default graphUrl;
